import classNames from "classnames";
import React from "react";
import CloseSvg from "../../../assets/svgs/CloseSvg";
import moment from "moment";
import ArrowUpRight from "../../../assets/svgs/ArrowUpRight";
import ReusableModal from "../../../components/Modals/ReusableModal";
import { usePublishToAthenaMutation } from "../../../features/athena/athenaApiSlice";
import { Form } from "react-bootstrap";
import Loading from "../../../components/Loading";
import { useLSStore } from "../../../context/ls-store";
import { Alert, Snackbar, Tooltip } from "@mui/material";
import { useCreateLogsMutation } from "../../../features/logs/logsApiSlice";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
} from "../../../constants/config.constants";
import CheckSvg from "../../../assets/svgs/CheckSvg";

const PublishAppointmentModal = ({
  publishOpen,
  setPublishOpen,
  weeks,
  setSuccessCard,
  selectedProvider,
  user,
  setRecallSchedule,
  appointmentsSelected,
  setAppointmentsSelected,
  filteredAppointments,
}) => {
  const [publishToAthena, { isLoading }] = usePublishToAthenaMutation();
  const [createLog] = useCreateLogsMutation();
  const [startDate, setStartDate] = React.useState();
  const [endDate, setEndDate] = React.useState();
  const setAlert = useLSStore((state) => state.setAlert);
  const [message, setMessage] = React.useState([]);
  const [openSlotAlert, setOpenSlotAlert] = React.useState(false);

  const showAlert = (msg) => {
    setMessage(msg);
    // const slotIssue = msg?.find((err) =>
    //   err.includes("Appointments slots are not available!")
    // );
    // if (slotIssue) {
    //   setOpenSlotAlert(true);
    // }
  };

  const onPublish = async ({ ignoreAvailability = false }) => {
    try {
      if ( !user?.organisation?.data?.isEnterprise) {
        showAlert([
          "You have not subscribed to the Athena integration plan, please subscribe if you want to publish to Athena",
        ]);
        return;
      }

      if (!user?.organisation?.practiceId) {
        showAlert(["You don't have a practice id, please add it to publish"]);
        return;
      }
      if ((!startDate || !endDate) && appointmentsSelected?.length === 0) {
        showAlert(["You didn't selected any start date or end date"]);
        return;
      }

      const payload = {
        activity: `Appointments published to Athena for the provider: ${selectedProvider.name} by User - ${user.details?.name}`,
        activityType: ACTIVITY_TYPE.SCHEDULE_PUBLISH,
        data: {
          providerId: selectedProvider.id,
        },
      };

      try {
        const { data } = await publishToAthena({
          ProviderID: selectedProvider.id,
          userId: user.id,
          startDate,
          endDate,
          practiceId: user?.organisation?.practiceId,
          providername: selectedProvider.name,
          ignoreAvailability,
          appointmentIds: appointmentsSelected,
          marketId: selectedProvider?.provider_market_id
        }).unwrap();

        setOpenSlotAlert(false);
        setPublishOpen(false);
        // setSuccessCard(true);
        setRecallSchedule?.(true);
        setAppointmentsSelected([]);
        setAlert({
          message: data?.message,
          severity: "success",
        });
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();
      } catch (error) {
        if (error?.data?.errors?.length > 0) {
          showAlert(error?.data?.errors);
          setRecallSchedule?.(true);
        }
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
      }
    } catch (err) {
      console.log(err, "err");
      showAlert([
        "(Error Code 001): We were unable to publish these schedules to Athena due to system timeout. Please try again in a few minutes. If the problem persists, please contact your system administrator.",
      ]);
    }
  };

  const onAdjustPublish = () => onPublish({ ignoreAvailability: true });

  return (
    <ReusableModal open={publishOpen} hideHeader>
      {isLoading && <Loading loading={isLoading} />}
      <div
        className={classNames(
          "flex absolute top-0 left-0 justify-center items-center w-screen h-full transition-all",
          publishOpen ? "z-50 opacity-100" : "opacity-0 -z-10"
        )}
      >
        <div className="bg-white w-[350px] md:w-[700px] rounded-md shadow-md flex flex-col">
          <div className="flex flex-row justify-between items-center p-4 w-full">
            <p className="m-0 text-2xl font-bold text-primaryblack">
              Publish Appointments
            </p>
            <button
              onClick={() => {
                setPublishOpen(false);
                setStartDate("");
                setEndDate("");
              }}
              className="flex justify-center items-center w-10 rounded-full aspect-square bg-primarylightgrey"
            >
              <CloseSvg color={"#3062D4"} />
            </button>
          </div>
          <div className="w-full border border-primarygrayborder" />
          <p className="px-4 pt-4 m-0 text-base text-left text-primarytextgrey">
            {appointmentsSelected?.length > 0
              ? "Please confirm the appointments selected for publish"
              : "Please specify the date range for this provider's schedule that you would like to publish to Athena."}
          </p>
          <div className="flex flex-col gap-2 p-4 w-full">
            <div className="flex relative flex-col gap-1">
              <div className="flex flex-row justify-between items-center">
                <p className="m-0 text-xl font-semibold">Provider Name</p>
              </div>
              <span className="text-lg">{selectedProvider.name}</span>
              {/* <div
                className={classNames(
                  "absolute left-0 top-20 z-50 w-full bg-white rounded-md border border-primarygrayborder",
                  startDateOpen
                    ? "overflow-x-auto max-h-44 opacity-100"
                    : "hidden overflow-hidden h-0 opacity-30"
                )}
              >
                {weeks.map((x, ind) => (
                  <button
                    key={ind}
                    onClick={() => {
                      setStartDate(moment(x.date).format("MMMM DD, YYYY"));
                      setStartDateOpen(false);
                    }}
                    className="flex flex-col items-start w-full transition-all hover:bg-slate-300"
                  >
                    <p className="p-2 m-0 text-base font-semibold cursor-pointer text-primaryblack">
                      {moment(x.date).format("MMMM DD, YYYY")}
                    </p>
                    {ind !== 6 && (
                      <div className="w-full border border-primarygrayborder" />
                    )}
                  </button>
                ))}
              </div> */}
            </div>
            {(!appointmentsSelected || appointmentsSelected?.length === 0) && (
              <div className="mb-2">
                <div className="my-2 d-flex align-items-center">
                  <p className="m-0 text-xl font-semibold">
                    Start Date<span className="text-danger">*</span>
                  </p>
                </div>
                <input
                  type="date"
                  value={startDate}
                  // min={moment().format("YYYY-MM-DD")}
                  onChange={(e) => {
                    setStartDate(e.target.value)
                    if (moment(endDate).isBefore(e.target.value)) {
                      setEndDate(e.target.value)
                    }
                  }}
                  className="p-2 rounded-md border border-primarygrayborder"
                />
              </div>
            )}
            {(!appointmentsSelected || appointmentsSelected?.length === 0) && (
              <div className="mb-2">
                <div className="my-2 d-flex align-items-center">
                  <p className="m-0 text-xl font-semibold">
                    End Date<span className="text-danger">*</span>
                  </p>
                </div>
                <input
                  type="date"
                  value={endDate}
                  min={startDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="p-2 rounded-md border border-primarygrayborder"
                />
              </div>
            )}
            {appointmentsSelected?.length > 0 && (
              <div
                className={classNames(
                  "flex overflow-auto overflow-x-hidden flex-col gap-2 px-2 py-2",
                  "h-[300px]"
                )}
              >
                {filteredAppointments
                  .filter((f) =>
                    appointmentsSelected?.includes(f.appointmentId)
                  )
                  .map((appointment, index) => {
                    return (
                      <div className="flex gap-3 items-start w-full">
                        <input
                          type="checkbox"
                          className="w-6 h-6"
                          checked={appointmentsSelected?.includes(
                            appointment.appointmentId
                          )}
                          onChange={() =>
                            setAppointmentsSelected((prev) =>
                              prev.includes(appointment.appointmentId)
                                ? prev.filter(
                                  (p) => p !== appointment.appointmentId
                                )
                                : [...prev, appointment.appointmentId]
                            )
                          }
                        />
                        <button
                          className={classNames(
                            "flex flex-col gap-4 p-3 w-full bg-white rounded-md border shadow-custom border-primarygrayborder"
                          )}
                        >
                          <div className="flex relative w-100">
                            <div className="flex flex-col gap-4 w-100">
                              <div className="flex flex-row justify-between w-100">
                                <div className="flex flex-row gap-4 items-center">
                                  <div
                                    className={classNames(
                                      "flex items-center justify-center rounded-full text-white text-sm font-semibold w-10 h-10",
                                      appointment.status === "UNLOCKED"
                                        ? "bg-[#F2C94C]"
                                        : appointment.status === "LOCKED"
                                          ? "bg-[#3062D4]"
                                          : "bg-[#6FCF97]"
                                    )}
                                  >
                                    {appointment.sequenceNo}
                                  </div>
                                  <div className="flex flex-col gap-0 items-start">
                                    <span className="flex flex-row gap-2 items-center text-xl font-bold whitespace-nowrap text-primaryblack">
                                      <span className="m-0">
                                        {appointment.patient.name}
                                      </span>
                                      <span>|</span>
                                      <span className="m-0">
                                        {appointment.location?.name !== null
                                          ? appointment.location?.name
                                          : "Private Residence"}
                                      </span>
                                    </span>
                                    <span className="m-0 text-base font-normal text-primarytextgrey">
                                      {`${appointment.distanceFromHome} miles from home`}
                                      {appointment?.appointmentType?.duration &&
                                        ` | ${appointment?.appointmentType?.duration}-min visit`}
                                    </span>
                                  </div>
                                </div>
                                {appointment.status === "PUBLISHED" && (
                                  <Tooltip title="Published to Athena">
                                    <div className="flex justify-center items-center w-10 h-10 bg-gray-50 rounded-lg">
                                      <CheckSvg color={"#6FCF97"} />
                                    </div>
                                  </Tooltip>
                                )}
                              </div>
                            </div>
                          </div>
                        </button>
                      </div>
                    );
                  })}
              </div>
            )}
            {startDate && (
              <p>
                You have selected{" "}
                {startDate && moment(startDate).format("MMMM DD, YYYY")} -{" "}
                {endDate && moment(endDate).format("MMMM DD, YYYY")}
              </p>
            )}
            {message.length > 0 && (
              <ul className="p-0 m-0 font-semibold text-red-500">
                {message?.map((msg) => {
                  return <li>{msg}</li>;
                })}
              </ul>
            )}
          </div>
          <div className="flex flex-row p-4">
            <div className="flex flex-row gap-2 justify-end items-center w-full">
              <button
                onClick={() => {
                  setPublishOpen(false);
                  setStartDate("");
                  setEndDate("");
                }}
                className="flex flex-row justify-center items-center px-3 py-2 rounded-md border-2 shadow-sm w-fit border-primaryred"
              >
                <p className="m-0 text-sm font-bold text-primaryred">
                  No, don't publish to EHR
                </p>
              </button>
              <button
                disabled={
                  (!startDate || !endDate) && appointmentsSelected?.length === 0
                }
                onClick={onPublish}
                className="flex flex-row justify-center items-center px-3 py-2 rounded-md border-2 shadow-sm w-fit bg-primarygreen border-primarygreen"
              >
                <p className="m-0 text-sm font-bold text-white">
                  Yes, publish to EHR
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <ReusableModal open={openSlotAlert} hideHeader>
        <div
          className={classNames(
            "flex absolute top-0 left-0 justify-center items-center w-screen h-full transition-all",
            publishOpen ? "z-50 opacity-100" : "opacity-0 -z-10"
          )}
        >
          <div className="bg-white w-[600px] rounded-md shadow-md flex flex-col">
            <div className="flex flex-row justify-between items-center p-4 w-full">
              <p className="m-0 text-2xl font-bold text-primaryblack">
                Adjust Provider Availability?
              </p>
              <button
                onClick={() => {
                  setOpenSlotAlert(false);
                }}
                className="flex justify-center items-center w-10 rounded-full aspect-square bg-primarylightgrey"
              >
                <CloseSvg color={"#3062D4"} />
              </button>
            </div>
            <div className="w-full border border-primarygrayborder" />
            <p className="px-4 pt-4 m-0 text-base text-left text-primarytextgrey">
              There are no slots available for the provider based on their
              current availability. Would you like to create slots by extending
              the time?
            </p>

            <div className="flex flex-row p-4">
              <div className="flex flex-row gap-2 justify-end items-center w-full">
                <button
                  onClick={() => {
                    setOpenSlotAlert(false);
                    setPublishOpen(false);
                    setStartDate("");
                    setEndDate("");
                  }}
                  className="flex flex-row justify-center items-center px-3 py-2 rounded-md border-2 shadow-sm w-fit border-primaryred"
                >
                  <p className="m-0 text-sm font-bold text-primaryred">No</p>
                </button>
                <button
                  onClick={onAdjustPublish}
                  className="flex flex-row justify-center items-center px-3 py-2 rounded-md border-2 shadow-sm w-fit bg-primarygreen border-primarygreen"
                >
                  <p className="m-0 text-sm font-bold text-white">
                    Yes, Adjust Availability
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ReusableModal>
    </ReusableModal>
  );
};

export default PublishAppointmentModal;
